import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const styles = {
  mt: {
    marginTop: 20
  }
}

class GridField extends React.PureComponent {

  render() {
    const { title, classes, needsUserInput, userInputComponent } = this.props
    return (
      <React.Fragment>
        <Grid item xs={12}>
          <Typography variant="subheading" className={classes.mt}>
            {title}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          {this.props.children}
        </Grid>
          <Grid item xs={12}>
              {needsUserInput && userInputComponent}
          </Grid>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(GridField);


// WEBPACK FOOTER //
// ./src/modules/shared/components/GridField.js